<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="container-fluid px-0">
            <div class="row">
                <div class="col-xl-4 col-lg-5 mb-4">
                    <b-card no-body class="shadow-sm">
                        <b-card-header class="d-flex justify-content-between align-items-center bg-white">
                            <b-button size="sm" variant="light" @click="$router.go(-1)">
                                <i class="mdi mdi-arrow-left me-1"></i> Back
                            </b-button>
                            <!-- <router-link :to="{ path: '/print-profile', query: { id: this.$route.query.id } }"
                                class="btn btn-sm btn-primary">
                                <i class="mdi mdi-printer-outline me-1"></i> Print
                            </router-link> -->
                        </b-card-header>

                        <div v-for="item in members" :key="'member-' + item.id">
                            <b-card-body class="text-center border-bottom">
                                <div class="avatar-md mx-auto mb-3">
                                    <span class="avatar-title rounded-circle bg-primary text-white fs-3">{{
                                        initials(item.name) }}</span>
                                </div>
                                <h5 class="mb-1">{{ item.name }}</h5>
                                <h5 class="text-info fw-bold">{{ item.member_id }}</h5>
                                <b-badge variant="primary" class="me-1"><i
                                        class="mdi mdi-card-account-details-outline me-1"></i>{{ item.member_id
                                        }}</b-badge>
                                <b-badge v-if="item.gender" variant="info"><i
                                        class="mdi mdi-gender-male-female me-1"></i>{{ item.gender }}</b-badge>
                                <b-badge v-if="item.status === 1" variant="success" class="ms-1">Active</b-badge>
                                <b-badge v-else-if="item.status === 2" variant="danger" class="ms-1">Inactive</b-badge>

                                <div class="mt-3">
                                    <span
                                        v-b-tooltip.hover="userData.permissions['edit_member'] != 1 ? 'Contact your administrator to allow this permission.' : ''"
                                        class="d-inline-block">
                                        <b-button size="sm"
                                            :variant="userData.permissions['edit_member'] == 1 ? 'outline-danger' : 'outline-secondary'"
                                            :disabled="userData.permissions['edit_member'] != 1"
                                            @click="initiatePasswordReset(item.member_id)">
                                            <i class="mdi mdi-lock-reset me-1"></i> Reset Password
                                        </b-button>
                                    </span>
                                </div>
                            </b-card-body>

                            <b-list-group flush>
                                <b-list-group-item v-if="item.telephone" class="d-flex align-items-start">
                                    <i class="mdi mdi-phone-outline text-primary fs-5 me-3"></i>
                                    <div><small class="text-muted d-block">Telephone</small>{{ item.telephone }}</div>
                                </b-list-group-item>
                                <b-list-group-item v-if="item.email" class="d-flex align-items-start">
                                    <i class="mdi mdi-email-outline text-primary fs-5 me-3"></i>
                                    <div><small class="text-muted d-block">Email</small><span>{{ item.email }}</span>
                                    </div>
                                </b-list-group-item>
                                <b-list-group-item v-if="item.age" class="d-flex align-items-start">
                                    <i class="mdi mdi-calendar-account text-primary fs-5 me-3"></i>
                                    <div><small class="text-muted d-block">Age</small>{{ item.age }} </div>
                                </b-list-group-item>
                                <b-list-group-item v-if="item.address" class="d-flex align-items-start">
                                    <i class="mdi mdi-map-marker-outline text-primary fs-5 me-3"></i>
                                    <div><small class="text-muted d-block">Address</small>{{ item.address }}</div>
                                </b-list-group-item>
                                <b-list-group-item v-if="item.nationality" class="d-flex align-items-start">
                                    <i class="mdi mdi-flag-outline text-primary fs-5 me-3"></i>
                                    <div><small class="text-muted d-block">Nationality</small>{{ item.nationality.name
                                        || item.nationality }}</div>
                                </b-list-group-item>
                                <b-list-group-item v-if="item.nin" class="d-flex align-items-start">
                                    <i class="mdi mdi-fingerprint text-primary fs-5 me-3"></i>
                                    <div><small class="text-muted d-block">NIN/Passport</small>{{ item.nin }}</div>
                                </b-list-group-item>
                            </b-list-group>
                        </div>

                        <!-- <b-card-footer class="bg-primary text-white">
                            <div class="d-flex align-items-center">
                                <i class="mdi mdi-cash-multiple fs-2 me-3"></i>
                                <div><small class="d-block text-white-50">Savings Balance</small><strong class="fs-5">{{
                                    commas(savingbalance) }} {{ userData.currency }}</strong></div>
                            </div>
                        </b-card-footer> -->
                    </b-card>
                </div>

                <div class="col-xl-8 col-lg-7">
                    <b-card no-body class="shadow-sm">
                        <b-card-body>
                            <b-tabs pills
                                nav-class="mb-4 flex-nowrap overflow-auto text-nowrap hide-scrollbar custom-pills"
                                content-class="pt-1">

                                <b-tab active>
                                    <template #title><i class="mdi mdi-information-outline"></i> Member Info</template>

                                    <div class="border-bottom pb-3 mb-4">
                                        <h5 class="mb-0">Additional Information</h5>
                                    </div>

                                    <div v-for="item in members" :key="'info-' + item.id">
                                        <div class="row">
                                            <div v-if="item.marital_status" class="col-sm-6 col-md-4 mb-4">
                                                <small class="text-muted d-block mb-1">Marital Status</small>
                                                <span class="fw-medium text-dark">{{ item.marital_status }}</span>
                                            </div>
                                            <div v-if="item.source_of_income" class="col-sm-6 col-md-4 mb-4">
                                                <small class="text-muted d-block mb-1">Source of Income</small>
                                                <span class="fw-medium text-dark">{{ item.source_of_income }}</span>
                                            </div>
                                            <div v-if="item.alternative_telephone" class="col-sm-6 col-md-4 mb-4">
                                                <small class="text-muted d-block mb-1">Alternative Telephone</small>
                                                <span class="fw-medium text-dark">{{ item.alternative_telephone
                                                    }}</span>
                                            </div>
                                            <div v-if="item.username" class="col-sm-6 col-md-4 mb-4">
                                                <small class="text-muted d-block mb-1">System Username</small>
                                                <span class="fw-medium text-dark">{{ item.username }}</span>
                                            </div>
                                            <div v-if="item.date_of_joining" class="col-sm-6 col-md-4 mb-4">
                                                <small class="text-muted d-block mb-1">Date of Joining</small>
                                                <span class="fw-medium text-dark">{{ item.date_of_joining }}</span>
                                            </div>
                                            <div v-if="item.sacco_member_id" class="col-sm-6 col-md-4 mb-4">
                                                <small class="text-muted d-block mb-1">Sacco Member ID</small>
                                                <span class="fw-medium text-dark">{{ item.sacco_member_id }}</span>
                                            </div>
                                            <div v-if="item.savingpackage" class="col-sm-6 col-md-4 mb-4">
                                                <small class="text-muted d-block mb-1">Saving Package</small>
                                                <span class="fw-medium text-dark">{{ item.savingpackage.name ||
                                                    item.savingpackage }}</span>
                                            </div>
                                            <div v-if="item.addedby" class="col-sm-6 col-md-4 mb-4">
                                                <small class="text-muted d-block mb-1">Registered By</small>
                                                <span class="fw-medium text-dark">{{ item.addedby }}</span>
                                            </div>
                                        </div>

                                        <div v-if="item.nokname || item.nok_relationship || item.nokcontact">
                                            <h5 class="font-size-15 mb-4 mt-2 border-bottom pb-2 text-primary">Next of
                                                Kin Details</h5>
                                            <div class="row">
                                                <div v-if="item.nokname" class="col-sm-4 mb-4">
                                                    <small class="text-muted d-block mb-1">Name</small>
                                                    <span class="fw-medium text-dark">{{ item.nokname }}</span>
                                                </div>
                                                <div v-if="item.nok_relationship" class="col-sm-4 mb-4">
                                                    <small class="text-muted d-block mb-1">Relationship</small>
                                                    <span class="fw-medium text-dark">{{ item.nok_relationship }}</span>
                                                </div>
                                                <div v-if="item.nokcontact" class="col-sm-4 mb-4">
                                                    <small class="text-muted d-block mb-1">Contact</small>
                                                    <span class="fw-medium text-dark">{{ item.nokcontact }}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="item.other_information">
                                            <h5 class="font-size-15 mb-3 mt-2 border-bottom pb-2 text-primary">Other
                                                Information</h5>
                                            <p class="text-muted">{{ item.other_information }}</p>
                                        </div>

                                        <div v-if="item.passport_photo || item.national_id_doc">
                                            <h5 class="font-size-15 mb-4 mt-4 border-bottom pb-2 text-primary">Documents
                                            </h5>
                                            <div class="row">
                                                <div v-if="item.passport_photo" class="col-md-6 mb-4">
                                                    <small class="text-muted d-block mb-2">Passport Picture</small>
                                                    <div class="border rounded p-2 d-flex flex-column align-items-center justify-content-center"
                                                        style="height: 300px; background: #f8f9fa;">
                                                        <img :src="item.passport_photo" alt="Passport Photo"
                                                            class="img-fluid rounded shadow-sm"
                                                            style="max-height: 100%; object-fit: contain;" />
                                                    </div>
                                                </div>

                                                <div v-if="item.national_id_doc" class="col-md-6 mb-4">
                                                    <small class="text-muted d-block mb-2">National ID /
                                                        Passport</small>
                                                    <div class="border rounded p-2 text-center d-flex flex-column"
                                                        style="height: 300px; background: #f8f9fa;">
                                                        <iframe
                                                            :src="item.national_id_doc + '#toolbar=0&navpanes=0&scrollbar=0&view=FitH'"
                                                            class="w-100 flex-grow-1 border-0 rounded shadow-sm"
                                                            title="National ID Document"></iframe>
                                                        <a :href="item.national_id_doc" target="_blank"
                                                            class="btn btn-sm btn-outline-primary mt-2">
                                                            <i class="mdi mdi-open-in-new me-1"></i> Open PDF in New Tab
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </b-tab>

                                <b-tab>
                                    <template #title><i class="mdi mdi-cash-multiple"></i> Savings</template>
                                    <div
                                        class="d-flex flex-wrap justify-content-between align-items-center border-bottom pb-3 mb-3">
                                        <h5 class="mb-2 mb-md-0">Savings History</h5>
                                        <b-badge variant="primary" class="p-2">Total: {{ commas(totalsavings)
                                            }}</b-badge>
                                    </div>
                                    <div class="table-responsive" v-if="savings.length">
                                        <table class="table table-sm table-hover align-middle mb-0">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>Amount</th>
                                                    <th>Payment Mode</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in savings" :key="item.id">
                                                    <td class="fw-bold text-primary">{{ commas(item.amount) }}</td>
                                                    <td>{{ item.mode_of_payment.name }} <small class="text-muted">· {{
                                                        item.reference }}</small></td>
                                                    <td>{{ item.date_of_payment }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="text-center text-muted py-5" v-else>
                                        <i class="mdi mdi-tray-arrow-down fs-2 d-block mb-2"></i>No savings records yet
                                    </div>
                                </b-tab>

                                <b-tab>
                                    <template #title><i class="mdi mdi-cash-minus"></i> Withdraws</template>
                                    <div
                                        class="d-flex flex-wrap justify-content-between align-items-center border-bottom pb-3 mb-3">
                                        <h5 class="mb-2 mb-md-0">Withdraw History</h5>
                                        <div>
                                            <b-badge variant="primary" class="p-2 me-1">Total: {{ commas(totalwithdraws)
                                                }}</b-badge>
                                            <b-badge variant="secondary" class="p-2">Charges: {{ commas(totalcharges)
                                                }}</b-badge>
                                        </div>
                                    </div>
                                    <div class="table-responsive" v-if="withdraws.length">
                                        <table class="table table-sm table-hover align-middle mb-0">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>Amount</th>
                                                    <th>Charges</th>
                                                    <th>Payment Mode</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in withdraws" :key="item.id">
                                                    <td class="fw-bold text-primary">{{ commas(item.amount) }}</td>
                                                    <td>{{ commas(item.charges) }}</td>
                                                    <td>{{ item.mode_of_payment.name }} <small class="text-muted">· {{
                                                        item.reference }}</small></td>
                                                    <td>{{ item.withdraw_date }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="text-center text-muted py-5" v-else>
                                        <i class="mdi mdi-tray-arrow-down fs-2 d-block mb-2"></i>No withdrawals yet
                                    </div>
                                </b-tab>

                                <b-tab>
                                    <template #title><i class="mdi mdi-chart-donut"></i> Shares</template>
                                    <div
                                        class="d-flex flex-wrap justify-content-between align-items-center border-bottom pb-3 mb-3">
                                        <h5 class="mb-2 mb-md-0">Shares History</h5>
                                        <b-badge variant="primary" class="p-2">Total: {{ commas(totalshares)
                                            }}</b-badge>
                                    </div>
                                    <div class="table-responsive" v-if="shares.length">
                                        <table class="table table-sm table-hover align-middle mb-0">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>Amount</th>
                                                    <th>Shares</th>
                                                    <th>Payment Mode</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in shares" :key="item.id">
                                                    <td class="fw-bold text-primary">{{ commas(item.amount) }}</td>
                                                    <td>{{ commas(item.share) }}</td>
                                                    <td>{{ item.mode_of_payment.name }} <small class="text-muted">· {{
                                                        item.reference }}</small></td>
                                                    <td>{{ item.date_of_payment }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="text-center text-muted py-5" v-else>
                                        <i class="mdi mdi-tray-arrow-down fs-2 d-block mb-2"></i>No share records yet
                                    </div>
                                </b-tab>

                                <b-tab>
                                    <template #title><i class="mdi mdi-bank"></i> Loans</template>
                                    <div
                                        class="d-flex flex-wrap justify-content-between align-items-center border-bottom pb-3 mb-3">
                                        <h5 class="mb-2 mb-md-0">Loan History</h5>
                                        <div>
                                            <b-badge variant="primary" class="p-2 me-1">Total: {{ commas(totalloan)
                                                }}</b-badge>
                                            <b-badge variant="secondary" class="p-2">Paid: {{ commas(totalpaid)
                                                }}</b-badge>
                                        </div>
                                    </div>
                                    <div class="table-responsive" v-if="loans.length">
                                        <table class="table table-sm table-hover align-middle mb-0">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>Loan</th>
                                                    <th>Amount</th>
                                                    <th>Charges</th>
                                                    <th>Total Due</th>
                                                    <th>Paid</th>
                                                    <th>Disbursed</th>
                                                    <th>Full Payment</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in loans" :key="item.id">
                                                    <td class="fw-bold">{{ item.loan_number }}</td>
                                                    <td class="fw-bold text-primary">{{ commas(item.amount) }}</td>
                                                    <td>{{ commas(item.charges) }}</td>
                                                    <td>{{ commas(item.payback) }}</td>
                                                    <td>{{ commas(item.paid) }}</td>
                                                    <td>{{ item.disbursement_date }}</td>
                                                    <td>{{ item.expirydate }}</td>
                                                    <td>
                                                        <b-badge variant="warning"
                                                            v-if="item.status === 'PENDING'">Applied</b-badge>
                                                        <b-badge variant="success"
                                                            v-else-if="item.status === 'APPROVED'">Approved</b-badge>
                                                        <b-badge variant="info"
                                                            v-else-if="item.status === 'RUNNING'">Running</b-badge>
                                                        <b-badge variant="primary"
                                                            v-else-if="item.status === 'CLOSED'">Closed</b-badge>
                                                        <b-badge variant="danger"
                                                            v-else-if="item.status === 'WRITEN_OFF'">Written
                                                            Off</b-badge>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="text-center text-muted py-5" v-else>
                                        <i class="mdi mdi-tray-arrow-down fs-2 d-block mb-2"></i>No loan records yet
                                    </div>
                                </b-tab>

                                <b-tab>
                                    <template #title><i class="mdi mdi-card-account-details-star-outline"></i>
                                        Subscriptions</template>
                                    <div
                                        class="d-flex flex-wrap justify-content-between align-items-center border-bottom pb-3 mb-3">
                                        <h5 class="mb-2 mb-md-0">Subscription Fees</h5>
                                        <b-badge variant="primary" class="p-2">Total: {{ commas(totalsubscription)
                                            }}</b-badge>
                                    </div>
                                    <div class="table-responsive" v-if="membershipfees.length">
                                        <table class="table table-sm table-hover align-middle mb-0">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>Amount</th>
                                                    <th>Payment Mode</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in membershipfees" :key="item.id">
                                                    <td class="fw-bold text-primary">{{ commas(item.amount) }}</td>
                                                    <td>{{ item.mode_of_payment.name }} <small class="text-muted">· {{
                                                        item.reference }}</small></td>
                                                    <td>{{ item.date_of_payment }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="text-center text-muted py-5" v-else>
                                        <i class="mdi mdi-tray-arrow-down fs-2 d-block mb-2"></i>No subscription fee
                                        records yet
                                    </div>
                                </b-tab>

                                <b-tab>
                                    <template #title><i class="mdi mdi-file-document-edit-outline"></i>
                                        Registration</template>
                                    <div class="border-bottom pb-3 mb-3">
                                        <h5 class="mb-0">Registration Fees</h5>
                                    </div>
                                    <div class="table-responsive" v-if="registrationfees.length">
                                        <table class="table table-sm table-hover align-middle mb-0">
                                            <thead class="table-light">
                                                <tr>
                                                    <th>Amount</th>
                                                    <th>Payment Mode</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in registrationfees" :key="item.id">
                                                    <td class="fw-bold text-primary">{{ commas(item.amount) }}</td>
                                                    <td>{{ item.mode_of_payment.name }} <small class="text-muted">· {{
                                                        item.reference }}</small></td>
                                                    <td>{{ item.date_of_payment }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="text-center text-muted py-5" v-else>
                                        <i class="mdi mdi-tray-arrow-down fs-2 d-block mb-2"></i>No registration fee
                                        records yet
                                    </div>
                                </b-tab>
                            </b-tabs>
                        </b-card-body>
                    </b-card>
                </div>
            </div>
        </div>

        <!-- Verify Admin Password Modal -->
        <b-modal id="verifyAdminPasswordModal" centered hide-header hide-footer @hidden="resetAdminVerification">
            <div class="modal-body text-center p-4">
                <div class="avatar-lg mx-auto mb-4">
                    <div class="avatar-title bg-soft-primary text-white display-4 rounded-circle">
                        <i class="mdi mdi-shield-key-outline"></i>
                    </div>
                </div>
                <h4 class="mb-3">Admin Verification</h4>
                <p class="text-muted mb-4">For security reasons, please enter your admin password to authorize this
                    action.</p>

                <div class="input-group auth-pass-inputgroup mb-4">
                    <input :type="showAdminPassword ? 'text' : 'password'" v-model="admin_password" class="form-control"
                        placeholder="Enter your admin password" required>
                    <button class="btn btn-light" type="button" @click="showAdminPassword = !showAdminPassword">
                        <i class="mdi" :class="showAdminPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"></i>
                    </button>
                </div>

                <div class="d-flex justify-content-center gap-2">
                    <b-button variant="light" @click="$bvModal.hide('verifyAdminPasswordModal')"
                        class="w-100">Cancel</b-button>
                    <b-button variant="primary" @click.prevent="verifyAdminPassword" class="w-100 fw-bold"
                        :disabled="!admin_password || loader_verify">
                        <b-spinner small v-if="loader_verify"></b-spinner>
                        <span v-else>Verify & Proceed</span>
                    </b-button>
                </div>
            </div>
        </b-modal>

        <!-- Set New Member Password Modal -->
        <b-modal id="setNewPasswordModal" centered hide-header hide-footer @hidden="resetNewPasswordForm">
            <div class="modal-body text-center p-4">
                <div class="avatar-lg mx-auto mb-4">
                    <div class="avatar-title bg-soft-danger text-white display-4 rounded-circle">
                        <i class="mdi mdi-lock-reset"></i>
                    </div>
                </div>
                <h4 class="mb-3">Set New Password</h4>
                <p class="text-muted mb-4">Enter a secure new password for this member.
                    <br>
                    Minimum 8 characters.</p>

                <div class="text-start mb-3">
                    <label class="form-label">New Password <span class="text-danger">*</span></label>
                    <div class="input-group auth-pass-inputgroup">
                        <input :type="showNewPassword ? 'text' : 'password'" v-model="new_member_password"
                            class="form-control" placeholder="Enter new password" required minlength="8">
                        <button class="btn btn-light" type="button" @click="showNewPassword = !showNewPassword">
                            <i class="mdi" :class="showNewPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"></i>
                        </button>
                    </div>
                </div>

                <div class="text-start mb-4">
                    <label class="form-label">Confirm Password <span class="text-danger">*</span></label>
                    <div class="input-group auth-pass-inputgroup mb-1">
                        <input :type="showConfirmPassword ? 'text' : 'password'" v-model="confirm_new_password"
                            class="form-control" placeholder="Confirm new password" required minlength="8"
                            :class="{ 'is-invalid': confirm_new_password && new_member_password !== confirm_new_password, 'is-valid': confirm_new_password && new_member_password === confirm_new_password }">
                        <button class="btn btn-light" type="button" @click="showConfirmPassword = !showConfirmPassword">
                            <i class="mdi" :class="showConfirmPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"></i>
                        </button>
                    </div>
                    <span v-if="confirm_new_password && new_member_password !== confirm_new_password"
                        class="text-danger small">Passwords do not match.</span>
                </div>

                <div class="d-flex justify-content-center gap-2">
                    <b-button variant="light" @click="$bvModal.hide('setNewPasswordModal')"
                        class="w-100">Cancel</b-button>
                    <b-button variant="danger" @click.prevent="submitNewPassword" class="w-100 fw-bold"
                        :disabled="!isNewPasswordValid || loader_reset">
                        <b-spinner small v-if="loader_reset"></b-spinner>
                        <span v-else><i class="mdi mdi-check-circle-outline me-1"></i> Confirm Reset</span>
                    </b-button>
                </div>
            </div>
        </b-modal>

    </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

export default {
    page: {
        title: "Member Profile",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Member Profile",
            items: [{ text: "Dashboard", to: "/" }, { text: "Members", active: true }],
            userData: JSON.parse(localStorage.getItem("user")) || { currency: "UGX", permissions: {} },
            members: [],
            savings: [],
            savingbalance: "",
            withdraws: [],
            shares: [],
            loans: [],
            transfers: [],
            membershipfees: [],
            registrationfees: [],

            // Password Reset State
            reset_member_id: "",
            admin_password: "",
            new_member_password: "",
            confirm_new_password: "",
            showAdminPassword: false,
            showNewPassword: false,
            showConfirmPassword: false,
            loader_verify: false,
            loader_reset: false
        };
    },
    created() {
        this.showmember();
        this.showsavings();
    },
    computed: {
        totalsubscription() { return this.membershipfees.reduce((total, item) => total + Number(item.amount || 0), 0); },
        totalsavings() { return this.savings.reduce((total, item) => total + Number(item.amount || 0), 0); },
        totalwithdraws() { return this.withdraws.reduce((total, item) => total + Number(item.amount || 0), 0); },
        totalcharges() { return this.withdraws.reduce((total, item) => total + Number(item.charges || 0), 0); },
        totalshares() { return this.shares.reduce((total, item) => total + Number(item.amount || 0), 0); },
        totalloan() { return this.loans.reduce((total, item) => total + Number(item.amount || 0), 0); },
        totalpaid() { return this.loans.reduce((total, item) => total + Number(item.paid || 0), 0); },

        isNewPasswordValid() {
            return this.new_member_password.length >= 8 && this.new_member_password === this.confirm_new_password;
        }
    },
    methods: {
        commas(value) { return value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0; },
        initials(name) {
            if (!name) return "?";
            const parts = name.trim().split(/\s+/);
            return ((parts[0] ? parts[0][0] : "") + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
        },
        async showmember() {
            this.member_id = this.$route.query.id;
            const response = await axios.get(`/memberprofile/${this.member_id}`);
            this.members = response.data.members;
        },
        async showsavings() {
            this.member_id = this.$route.query.id;
            const response = await axios.get(`/profilesavings/${this.member_id}`);
            this.savings = response.data.savings;
            this.showwithdraw(); this.showshares(); this.showloans(); this.showmembership(); this.showregistration(); this.FindBalance();
        },
        async FindBalance() { const response = await axios.get(`/savingsbalance/${this.$route.query.id}`); this.savingbalance = response.data.balance; },
        async showwithdraw() { const response = await axios.get(`/profilewithdraws/${this.$route.query.id}`); this.withdraws = response.data.withdraws; },
        async showshares() { const response = await axios.get(`/profileshares/${this.$route.query.id}`); this.shares = response.data.shares; },
        async showregistration() { const response = await axios.get(`/profileregistrationfees/${this.$route.query.id}`); this.registrationfees = response.data.registrationfees; },
        async showmembership() { const response = await axios.get(`/profilemembershipfees/${this.$route.query.id}`); this.membershipfees = response.data.membershipfees; },
        async showloans() { const response = await axios.get(`/loans/member-profile/${this.$route.query.id}`); this.loans = response.data.loans; },
        async showtransfers() { const response = await axios.get(`/profiletransfers/${this.$route.query.id}`); this.transfers = response.data.transfers; },

        // Password Reset Methods
        initiatePasswordReset(member_id) {
            this.reset_member_id = member_id;
            this.$bvModal.show("verifyAdminPasswordModal");
        },
        resetAdminVerification() {
            this.admin_password = '';
            this.showAdminPassword = false;
        },
        resetNewPasswordForm() {
            this.new_member_password = '';
            this.confirm_new_password = '';
            this.showNewPassword = false;
            this.showConfirmPassword = false;
        },
        async verifyAdminPassword() {
            this.loader_verify = true;
            try {
                const response = await axios.post('/verify-admin-password', { password: this.admin_password });
                if (response.status === 200) {
                    this.$bvModal.hide("verifyAdminPasswordModal");
                    this.$bvModal.show("setNewPasswordModal");
                }
            } catch (error) {
                this.$toast.error(error.response?.data?.message || "Verification failed. Incorrect password.");
            } finally {
                this.loader_verify = false;
                this.resetAdminVerification();
            }
        },
        async submitNewPassword() {
            this.loader_reset = true;
            try {
                const response = await axios.post('/admin-reset-member-password', {
                    member_id: this.reset_member_id,
                    password: this.new_member_password
                });
                if (response.status === 200) {
                    this.$toast.success("Member password successfully reset.");
                    this.$bvModal.hide("setNewPasswordModal");
                }
            } catch (error) {
                this.$toast.error(error.response?.data?.message || "Failed to reset password.");
            } finally {
                this.loader_reset = false;
                this.resetNewPasswordForm();
                this.reset_member_id = '';
            }
        }
    }
};
</script>

<style scoped>
/* Forces the tab items to stay on one line */
:deep(.custom-pills .nav-item) {
    white-space: nowrap;
}

/* Hides the scrollbar on the tabs but keeps them horizontally scrollable */
:deep(.hide-scrollbar) {
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}

:deep(.hide-scrollbar::-webkit-scrollbar) {
    display: none;
    /* Chrome, Safari and Opera */
}
</style>